import { onDocumentReady } from '../utils/events';

/**
 * Pre-selects a product in the Study contact form when the page is reached
 * from a medical brand page (e.g. .../contact/?product=micronjet#contact-tab-study).
 * Matches the Gravity Forms image choice by its visible label, so it works
 * regardless of the field's internal choice values.
 */
onDocumentReady(() => {
  const product = (
    new URLSearchParams(window.location.search).get('product') || ''
  )
    .toLowerCase()
    .trim();
  if (!product) return;

  const KEYWORDS = {
    nctf: 'nctf',
    // Match "art fil…" so it works whether the choice reads "Art Filler"
    // or the current "Art Filter" (typo in the form).
    'art-filler': 'art fil',
    micronjet: 'micronjet',
    pliaglis: 'pliaglis',
  };
  const keyword = KEYWORDS[product] || product.replace(/-/g, ' ');

  const select = () => {
    const choices = document.querySelectorAll('.gchoice');
    if (!choices.length) return false;

    let matched = false;
    choices.forEach((choice) => {
      const input = choice.querySelector(
        'input[type="checkbox"], input[type="radio"]'
      );
      if (!input) return;
      if ((choice.textContent || '').toLowerCase().includes(keyword)) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        matched = true;
      }
    });
    return matched;
  };

  // The Study tab / Gravity Form can render a beat after load — retry briefly.
  let tries = 0;
  const timer = window.setInterval(() => {
    if (select() || (tries += 1) > 20) window.clearInterval(timer);
  }, 150);
});
